/*/ # Survey & Assessment API
// The survey objects is the top level object for this part of the API
// This API can be used to retrieve surveys from the EverFi Platform,
// view the current user's responses to that survey, and record new
// responses for the user.
//
// To work with a survey you must know its 'slug'. This requires the
// survey to be setup on the everfi platform before you can use it.
// If you need this setup please ask EverFi to do so and we will
// provide you with the slugs.
//
// Working with the Survey Object:
// ```
//  // Load the survey like so:
//  survey = new EF.Models.Survey({slug: '69-example_sdk_survey'});
//  survey.fetch({ success: surveyLoaded});
//
//  // Once loaded you may traverse the associations on a survey to show the
//  // questions. Below is just an example to show the associations:
//  survey.sections.each(function(section){
//    section.questions.each(function(question){
//      question.get('text'); // do something with the question text
//      question.answers.each(function(answer){
//        answer.get('text'); // display each answer
//        answer.get('correct'); // whether or not this is the correct answer.
//      });
//    });
//  });
//
//
//  // If you want to record scores you must instantiate a Response Set object
//  // like so:
//  var responseSet;
//  survey.initResponseSet({success: function(resp){ responseSet = resp; }});
//  // this makes a call to our backend to init or retrieve the current users
//  // response set for this survey. Once retrieved you may
//  // inspect the user's responses like so:
//  var response = responseSet.responseForQuestionByName('my_question_name'); // by name
//  var response = responseSet.responseForQuestionById(2040); // by id
//
//  // To record a new response to question:
//  responseSet.answerQuestion(question_id, answer_id, {success: function(){
//    // successfully saved response;
//  });
//```
//
//
/*/
(function(EF, undefined) {

  var Survey = Backbone.Model.extend({

    urlRoot: '/api/surveys/',

    url: function() {
      return EF.surveyUrl(this.urlRoot + this.get('slug')) + '.json';
    },

    // Once the survey
    initResponseSet: function(options) {
      var response_set = new EF.Models.ResponseSet({user_id: EF.enrollment.get('userId'), enrollment_id: EF.enrollment.get('id')}, {survey: this});
      response_set.save({}, options);
    },

    parse: function(resp) {
      this.sections = new EF.Collections.SectionsCollection(resp.sections);
      delete resp.sections;
      return resp;
    }
  });

  _.extend(EF.Models, {
    Survey: Survey
  });

})(EF);
